// SHADOW NETWORK™ — FASE 1 to FASE 5 i18n strings (ES/EN/SK).
// Separate module to avoid touching the large legacy shadow.js dictionary.
export const SHADOW_FASES_I18N = {
  es: {
    // ── Sentiment (1.1) ──
    sw_title: "Sentimiento global",
    sw_sub: "Basado en {n} análisis de hoy",
    sw_bullish: "Alcista",
    sw_bearish: "Bajista",
    sw_neutral: "Neutral",
    sw_empty: "Aún no hay sentimiento hoy",

    // ── Polls (1.2) ──
    poll_first_to_vote: "Sé el primero en votar",
    poll_votes_one: "{n} voto",
    poll_votes_other: "{n} votos",
    poll_you_voted: " · Has votado ✓",
    publish_poll_label: "Encuesta",
    publish_poll_pro: "PRO",
    publish_poll_q_ph: "¿BTC romperá los 100k esta semana?",
    publish_poll_opt_ph: "Opción {n}",
    publish_poll_add: "+ Añadir opción ({n}/4)",

    // ── Tips (1.5) ──
    tip_btn: "Tip",
    tip_modal_eyebrow: "Propina USDC",
    tip_modal_title: "Apoya a {name}",
    tip_modal_sub: "Wallet-to-wallet, 0% comisión. Red preferente: Base L2.",

    // ── Premium signals (3.2) ──
    premium_lock_title: "Señal premium",
    premium_lock_sub: "Suscríbete a @{u} para ver el setup completo.",
    premium_lock_cta: "Suscribirse →",
    publish_premium_label: "Señal premium",
    publish_premium_sub: "Solo suscriptores verán el setup completo",

    // ── Co-author (3.3) ──
    publish_coauth_label: "Co-firmar análisis",
    publish_coauth_sub: "Invitar a otro analista (debe aceptar)",
    publish_coauth_ph: "@username del co-analista (PRO)",
    publish_coauth_sent: "✓ Invitación enviada. Esperando aceptación.",
    publish_coauth_err: "No se pudo invitar (¿usuario PRO existente?).",

    // ── Repost (1.3) ──
    repost_done: "Reposteado",
    repost_action: "Repostear",

    // ── Monetiza (3.1) ──
    mz_title: "Monetiza tu análisis",
    mz_login_sub: "Inicia sesión.",
    mz_pro_sub: "Disponible solo para PRO.",
    mz_eyebrow: "// FASE 3 · MONETIZACIÓN",
    mz_h1_sub: "Conecta tu cuenta Stripe, define tu precio mensual y cobra a tus seguidores directamente. La plataforma se queda con un 20%.",
    mz_connect_title: "Cuenta Stripe Connect",
    mz_stat_account_id: "Account ID",
    mz_stat_onboarded: "Onboarded",
    mz_stat_charges: "Charges",
    mz_stat_payouts: "Payouts",
    mz_yes: "Sí",
    mz_no: "No",
    mz_active: "Activos",
    mz_ready: "Listos",
    mz_onboard_btn: "Empezar onboarding",
    mz_onboard_update: "Actualizar onboarding",
    mz_onboard_err: "Error iniciando onboarding",
    mz_price_title: "Tu precio mensual",
    mz_price_sub: "Entre €1 y €200. Recibirás el 80% — la plataforma retiene el 20%.",
    mz_price_per_month: "/mes",
    mz_price_invalid: "Precio entre €1 y €200",
    mz_price_save_err: "Error guardando",
    mz_subs_title: "Tus suscriptores",
    mz_subs_empty_share: "Aún sin suscriptores. Comparte tu perfil.",
    mz_subs_empty_onboard: "Aún sin suscriptores. Completa el onboarding primero.",

    // ── Co-analyst split (F5.5) ──
    ca_title: "Co-analista (split de revenue)",
    ca_sub: "Designa a otro analista PRO para que reciba automáticamente un % de cada pago de suscripción que recibes. Pago vía Stripe Transfer desde tu balance.",
    ca_username_ph: "@username del co-analista (PRO)",
    ca_pct_label: "% para co-analista",
    ca_save: "Guardar",
    ca_remove: "Quitar",
    ca_current: "Co-analista activo: @{name} · recibe {pct}% de cada pago",
    ca_none: "Sin co-analista configurado.",
    ca_err_404: "Usuario no encontrado",
    ca_err_self: "No puedes ser tu propio co-analista",
    ca_err_pro: "El co-analista debe ser PRO",
    ca_err_onboard: "El co-analista debe completar onboarding Stripe Connect",
    ca_err_invalid_pct: "% debe estar entre 1 y 99",
    ca_transfers_title: "Splits recientes",
    ca_transfers_empty: "Sin pagos a co-analista todavía.",
    ca_transfer_sent: "Enviado",
    ca_transfer_received: "Recibido",
    ca_transfer_failed: "Fallido",
    ca_transfer_pending: "Pendiente",

    // ── Lists index (3.4) ──
    ls_title: "Listas curadas",
    ls_login_sub: "Inicia sesión para crear y gestionar tus listas de operadores.",
    ls_eyebrow: "// FASE 3.5 · LISTAS CURADAS",
    ls_h1: "Tus listas de operadores",
    ls_h1_sub: "Agrupa traders por estilo, asset class o cualquier criterio. Cada lista tiene su propio feed.",
    ls_quota_hint: "Tu límite: {n} (sube a PRO para 20).",
    ls_used: "{u}/{l} listas",
    ls_new_btn: "Nueva lista",
    ls_empty: "Aún no tienes listas. Crea la primera arriba.",
    ls_vis_public: "Pública",
    ls_vis_private: "Privada",
    ls_members_count: "{n} miembros",
    ls_modal_title: "Nueva lista",
    ls_f_name: "Nombre",
    ls_f_name_ph: "Bitcoin OG, Macro Bears, …",
    ls_f_desc: "Descripción (opcional)",
    ls_f_vis: "Visibilidad",
    ls_create: "Crear",
    ls_confirm_delete: "¿Eliminar esta lista?",
    ls_err_name_short: "El nombre debe tener al menos 2 caracteres",

    // ── List detail (3.4) ──
    ld_not_found: "Lista no encontrada o privada",
    ld_back_my: "// MIS LISTAS",
    ld_back_my_lists: "← Mis listas",
    ld_by: "Por",
    ld_members: "Miembros",
    ld_member_ph: "@username",
    ld_members_empty: "Sin miembros aún.",
    ld_feed: "Feed de la lista",
    ld_feed_empty_add: "Añade miembros para ver su feed aquí.",
    ld_feed_empty_noposts: "Los miembros aún no han publicado nada.",
    ld_remove_confirm: "¿Quitar de la lista?",

    // ── Subscribe (3.1) ──
    sub_subscribed: "Suscrito",
    sub_per_month: "/mes",
    sub_failed: "No se pudo iniciar la suscripción",

    // ── Add to list (3.4) ──
    atl_label: "Listas",
    atl_tooltip: "Añadir a una lista",
    atl_header: "Añadir a lista",
    atl_empty: "No tienes listas.",
    atl_create: "Crear una →",

    // ── AI Score (2.5) ──
    publish_ai_label: "Score IA (preview)",
    publish_ai_sub: "Powered by Claude · No afecta tu ranking real",
    publish_ai_btn: "Evaluar",
    publish_ai_busy: "Evaluando…",
    publish_ai_risks: "Riesgos clave",
    publish_ai_min: "Necesitas título y al menos 30 caracteres de análisis para la preview",

    // ── Daily Brief (2.6) ──
    db_title: "Brief IA",
    db_takeaway: "💡 {takeaway}",

    // ── Alerts (2.1) ──
    al_title: "Alertas de precio",
    al_sub: "Define un objetivo y te notificamos en cuanto el precio lo cruce. Datos vía CoinGecko, refresco cada minuto.",
    al_login_sub: "Crea alertas y recibe una notificación cuando el precio cruce tu objetivo.",
    al_ticker: "Ticker",
    al_when: "Cuando",
    al_target: "Precio objetivo (USD)",
    al_spot: "spot",
    al_create: "Crear",
    al_my: "Mis alertas ({n})",
    al_empty: "Sin alertas activas. Crea la primera arriba.",
    al_invalid_target: "Precio objetivo inválido",
    al_above: "ABOVE",
    al_below: "BELOW",
    al_triggered: "✓ Disparada",
    al_last_spot: "Último spot",
    al_created_at: "Creada",
    al_triggered_at: "Disparada",
    al_confirm_delete: "¿Eliminar esta alerta?",

    // ── Journal (2.2) ──
    j_title: "Trading Journal",
    j_login_sub: "Inicia sesión para llevar tu diario de trades.",
    j_pro_title: "Trading Journal PRO",
    j_pro_sub: "Lleva un registro detallado de cada operación con cálculo automático de PnL, win-rate y curva de equity. Disponible solo para operadores PRO.",
    j_pro_cta: "Hazte PRO",
    j_pro_busy: "Redirigiendo…",
    j_h1_eyebrow: "TRADING JOURNAL",
    j_h1: "Tu diario de trading",
    j_h1_sub: "Anota cada operación, cierra con el precio de salida y aprende de tu estadística.",
    j_new: "Nueva operación",
    j_stats_winrate: "Win-rate",
    j_stats_pnl: "PnL acum.",
    j_stats_avg: "Promedio",
    j_stats_closed: "Cerradas",
    j_stats_open: "Abiertas",
    j_equity_title: "Curva de equity (PnL acumulado %)",
    j_ops: "Operaciones ({n})",
    j_loading: "Cargando…",
    j_empty: "Sin operaciones. Crea la primera arriba.",
    j_th_ticker: "Ticker",
    j_th_side: "Side",
    j_th_entry: "Entry",
    j_th_exit: "Exit",
    j_th_pnl: "PnL %",
    j_th_date: "Fecha",
    j_open: "— ABIERTA",
    j_close_btn: "Cerrar",
    j_close_modal_title: "Nueva operación",
    j_f_ticker: "Ticker",
    j_f_side: "Side",
    j_f_entry: "Entry price (USD)",
    j_f_exit: "Exit price (opcional)",
    j_f_size: "Tamaño (USD)",
    j_f_notes: "Notas (opcional)",
    j_f_notes_ph: "Setup, niveles clave, gestión...",
    j_f_lesson: "Lección aprendida (opcional)",
    j_f_lesson_ph: "¿Qué aprendiste con esta operación?",
    j_f_save: "Guardar",
    j_f_cancel: "Cancelar",
    j_f_exit_invalid: "Precio de entrada inválido",
    j_confirm_delete: "¿Eliminar esta entrada del journal?",

    // ── Mentor IA (4.1) ──
    m_title: "Mentor IA",
    m_login_sub: "Inicia sesión para hablar con tu mentor de trading.",
    m_new: "Nueva sesión",
    m_empty: "Sin sesiones aún.",
    m_quota_pro: "PRO · ilimitado",
    m_quota_used: "{u}/{l} hoy",
    m_examples: "Pregunta lo que necesites. Ejemplos:",
    m_ex1: "¿Cómo dimensiono mi posición con ATR?",
    m_ex2: "Revísame este setup: BTC 4H, OB en 92k…",
    m_ex3: "¿Qué hago tras 3 stops seguidos?",
    m_thinking: "pensando…",
    m_input_ph: "Pregunta a tu mentor… (Enter para enviar, Shift+Enter salto)",
    m_role: "MENTOR",
    m_confirm_delete: "¿Eliminar esta sesión?",
    m_err_session: "No se pudo iniciar la sesión",
    m_err_default: "Error del mentor",

    // ── Tokens (4.3 + 5) ──
    t_login_sub: "Inicia sesión para ver tu balance y canjes.",
    t_eyebrow: "$REBEL TOKENS",
    t_h1: "Tu economía RE₿EL",
    t_h1_sub: "Tokens virtuales que ganas con tu actividad y canjeas por recompensas. Migración on-chain prevista para FASE 5.",
    t_balance: "Balance actual",
    t_total: "Acumulado total",
    t_how_to_earn: "Cómo ganar",
    t_e_publish: "📝 Publicar análisis · +10",
    t_e_react: "❤️ Recibir reacción · +1",
    t_e_correct: "✅ Acertar dirección · +50",
    t_e_referral: "🤝 Referido verificado · +100",
    t_redeem: "Canjea tus tokens",
    t_redeem_btn: "Canjear",
    t_redeem_ok: "Canje realizado",
    t_redeem_active: "Activo hasta {when}",
    t_history: "Historial ({n})",
    t_history_empty: "Sin actividad. Publica un análisis para ganar tus primeros tokens.",
    t_r_publish: "📝 Publicar análisis",
    t_r_reaction: "❤️ Recibir reacción",
    t_r_direction: "✅ Acertar dirección",
    t_r_referral: "🤝 Referido verificado",

    // ── On-chain (5) ──
    oc_title: "On-chain $REBEL (Base L2)",
    oc_contract_link: "contrato ↗",
    oc_sub: "Convierte tu saldo virtual a $REBEL on-chain (1:1, Base L2). Tx gas la cubre la plataforma.",
    oc_wallet: "Tu wallet (0x...)",
    oc_balance: "On-chain",
    oc_amount: "Cantidad a convertir",
    oc_convert: "Convertir",
    oc_invalid_wallet: "Wallet inválida",
    oc_invalid_amount: "Cantidad inválida",
    oc_insufficient: "Saldo virtual insuficiente",
    oc_failed: "Conversión fallida",
    oc_success: "✓ {n} $REBEL enviados on-chain",
    oc_view_tx: "Ver tx en BaseScan",

    // ── Navbar pill (4.3) ──
    pill_tooltip: "{n} $REBEL · Ver economía",

    // ── Wallet connect (Web3Modal-lite via EIP-1193) ──
    oc_connect: "Conectar wallet",
    oc_connecting: "Conectando…",
    oc_connected: "Conectado",
    oc_disconnect: "Desconectar",
    oc_no_wallet: "No detectamos wallet (MetaMask / Coinbase). Instala una extensión.",
    oc_wrong_chain: "Tu wallet no está en Base L2.",
    oc_switch_chain: "Cambiar a Base",
    oc_choose_wallet: "Elige una wallet",

    // ── Tokens Page hero & UI ──
    tk_hero_eyebrow: "// BASE L2 · ERC-20 · LIVE ON-CHAIN",
    tk_hero_sub: "El token nativo de RE₿EL Academy y Shadow Network. Ganas R₿L con tu actividad, lo canjeas por recompensas, y lo puedes mover a tu wallet on-chain en Base L2.",
    tk_stat_price: "Precio R₿L",
    tk_stat_supply: "Supply total",
    tk_stat_fee: "Fee → treasury",
    tk_stat_per_swap: "por swap",
    tk_stat_liq: "Liquidez DEX",
    tk_swap_title: "Compra R₿L",
    tk_swap_sub: "Swap ETH → R₿L directamente desde tu wallet conectada en Base L2. Liquidez 24/7.",
    tk_swap_chart: "Ver chart",
    tk_balance_label: "Tu balance R₿L (RE₿EL Academy)",
    tk_balance_total: "Acumulado total:",
    tk_how_earn_title: "Cómo ganar R₿L",
    tk_login_sub: "Inicia sesión para ver tu balance R₿L y canjear recompensas.",
    tk_redeem_title: "Canjear R₿L",
    tk_redeem_btn: "Canjear",
    tk_redeem_ok: "Canje realizado",
    tk_redeem_active: "Activo hasta {when}",
    tk_history_title: "Historial",
    tk_history_empty: "Sin actividad. Publica un análisis para ganar tus primeros R₿L.",
    tk_def_coupon_name: "🛒 Descuento tienda",
    tk_def_coupon_desc: "Cupón de -5€ canjeable en la tienda RE₿EL Academy.",
    tk_def_boost_name: "🚀 Boost feed 24h",
    tk_def_boost_desc: "Tu próximo análisis aparece destacado durante 24 horas en Shadow Network.",
    tk_def_badge_name: "🎖️ Badge Veterano",
    tk_def_badge_desc: "Insignia permanente 'Veterano' en tu perfil RE₿EL. Single-use.",
    tk_roadmap_title: "Roadmap R₿L",
    tk_phase1_title: "Fase 1 — Completada",
    tk_phase1_i1: "Deploy ERC-20 RE₿EL (R₿L) en Base L2 via Thirdweb",
    tk_phase1_i2: "Bonding curve activa — precio dinámico",
    tk_phase1_i3: "Treasury wallet fondeada",
    tk_phase1_i4: "Ledger off-chain activo en RE₿EL Academy",
    tk_phase1_i5: "Earning rates: publicar +10 · reacción +1 · acertar +50 · referido +100",
    tk_phase2_title: "Fase 2 — Completada",
    tk_phase2_i1: "Contador R₿L en navbar · canjes (descuento tienda, boost feed, badge Veterano)",
    tk_phase2_i2: "Shadow Network: análisis, polls, reposts, menciones, tips USDC, co-firmas, listas curadas",
    tk_phase2_i3: "Mentor IA Claude (FREE 10 msgs/día · PRO ilimitado) · Trading Journal PRO · Alertas precio",
    tk_phase2_i4: "Señales premium + suscripciones a analistas via Stripe Connect (split 80/20)",
    tk_phase2_i5: "Desafíos semanales con XP + sistema de niveles (Rookie · Trader · Shadow · Legend)",
    tk_phase3_title: "Fase 3 — Completada (on-chain + Web3)",
    tk_phase3_i1: "Conversión virtual → on-chain 1:1 con verificación de treasury (Base L2)",
    tk_phase3_i2: "Dual ledger: off-chain + on-chain corriendo en paralelo",
    tk_phase3_i3: "Wallet Connect EIP-1193 (MetaMask + Coinbase) con auto-switch a Base",
    tk_phase3_i4: "Co-analyst split (F5.5): Stripe Transfer automático al co-firmante post-pago",
    tk_phase3_i5: "Mentor IA con histórico, gráfico de velas live (DexScreener · TradingView)",
    tk_phase4_title: "Fase 4 — Completada (liquidez & listings)",
    tk_phase4_i1: "Uniswap (Base) — listado y operativo",
    tk_phase4_i2: "Pool de liquidez ETH/R₿L en Uniswap — activo",
    tk_phase4_i3: "Aerodrome Finance (DEX nativo Base) — listado",
    tk_phase4_i4: "PancakeSwap (Base) — listado",
    tk_phase4_i5: "CoinGecko + CoinMarketCap — listing activo",
    tk_phase4_i6: "Market maker activo + snapshot/claim para holders tempranos",
    tk_phase5_title: "Fase 5 — Completada (Ecosistema RE₿EL completo)",
    tk_phase5_i1: "Governance: votación comunidad RE₿EL con R₿L",
    tk_phase5_i2: "Airdrop a holders diplomas RE₿EL Proof™",
    tk_phase5_i3: "R₿L como acceso a cursos y membresías PRO en RE₿EL Academy",
    tk_phase5_i4: "Copy Simulator con R₿L",
    tk_phase5_i5: "Integración TrendIA — análisis con R₿L",
    tk_phase6_title: "Fase 6 — Token Economy avanzada",
    tk_phase6_i1: "R₿L Vault — yield sharing con ingresos de la academia · 20% de cada pago PRO va al Vault · distribución mensual",
    tk_phase6_i2: "Burning mecánico de R₿L — 5% de cada pago PRO quemado permanentemente · supply deflacionario",
    tk_phase6_i3: "Swap Widget nativo en rebelbtc.com — compra R₿L directamente en la plataforma · Uniswap V3 Base",
    tk_phase6_i4: "Dashboard de tokenomics en tiempo real — precio · market cap · holders · volumen 24h · LP bloqueado",
    tk_phase6_i5: "Banners promocionales 50% descuento PRO con R₿L — visibles en toda la plataforma para usuarios sin PRO",
    tk_phase6_i6: "Listing en CoinGecko — solicitud enviada · revisión en 10-20 días hábiles",
    tk_phase6_i7: "Listing en CoinMarketCap — solicitud enviada · ticket #1372525",
    tk_phase7_title: "Fase 7 — Expansión del ecosistema",
    tk_phase7_i1: "RE₿EL Wallet — app móvil con marca propia (iOS + Android)",
    tk_phase7_i2: "Torneos de trading con R₿L como premio",
    tk_phase7_i3: "RE₿EL Mentors — analistas cobran en R₿L",
    tk_phase7_i4: "Clases en vivo tokenizadas con R₿L de entrada",
    tk_phase7_i5: "NFT Achievement Badges por milestones",
    tk_phase7_i6: "RE₿EL DAO — gobernanza on-chain completa",
    tk_phase7_i7: "Listing en CEX (MEXC, Gate.io, BitMart)",
    tk_phase7_i8: "Integración TrendIA completa en la plataforma",

    // ── Common ──
    common_back: "// SHADOW NETWORK",
    common_login: "Iniciar sesión",
    common_loading: "Cargando…",
    common_save: "Guardar",
    common_cancel: "Cancelar",
  },

  en: {
    sw_title: "Global sentiment",
    sw_sub: "Based on {n} analyses today",
    sw_bullish: "Bullish",
    sw_bearish: "Bearish",
    sw_neutral: "Neutral",
    sw_empty: "No sentiment data yet today",

    poll_first_to_vote: "Be the first to vote",
    poll_votes_one: "{n} vote",
    poll_votes_other: "{n} votes",
    poll_you_voted: " · You voted ✓",
    publish_poll_label: "Poll",
    publish_poll_pro: "PRO",
    publish_poll_q_ph: "Will BTC break $100k this week?",
    publish_poll_opt_ph: "Option {n}",
    publish_poll_add: "+ Add option ({n}/4)",

    tip_btn: "Tip",
    tip_modal_eyebrow: "USDC Tip",
    tip_modal_title: "Support {name}",
    tip_modal_sub: "Wallet-to-wallet, 0% fee. Preferred network: Base L2.",

    premium_lock_title: "Premium signal",
    premium_lock_sub: "Subscribe to @{u} to view the full setup.",
    premium_lock_cta: "Subscribe →",
    publish_premium_label: "Premium signal",
    publish_premium_sub: "Only subscribers will see the full setup",

    publish_coauth_label: "Co-sign analysis",
    publish_coauth_sub: "Invite another analyst (must accept)",
    publish_coauth_ph: "@username of co-analyst (PRO)",
    publish_coauth_sent: "✓ Invite sent. Awaiting acceptance.",
    publish_coauth_err: "Could not invite (does PRO user exist?).",

    repost_done: "Reposted",
    repost_action: "Repost",

    mz_title: "Monetize your analysis",
    mz_login_sub: "Sign in.",
    mz_pro_sub: "PRO only.",
    mz_eyebrow: "// PHASE 3 · MONETIZATION",
    mz_h1_sub: "Connect your Stripe account, set your monthly price and charge your followers directly. The platform keeps 20%.",
    mz_connect_title: "Stripe Connect account",
    mz_stat_account_id: "Account ID",
    mz_stat_onboarded: "Onboarded",
    mz_stat_charges: "Charges",
    mz_stat_payouts: "Payouts",
    mz_yes: "Yes",
    mz_no: "No",
    mz_active: "Active",
    mz_ready: "Ready",
    mz_onboard_btn: "Start onboarding",
    mz_onboard_update: "Update onboarding",
    mz_onboard_err: "Error starting onboarding",
    mz_price_title: "Your monthly price",
    mz_price_sub: "Between €1 and €200. You receive 80% — the platform keeps 20%.",
    mz_price_per_month: "/mo",
    mz_price_invalid: "Price between €1 and €200",
    mz_price_save_err: "Save error",
    mz_subs_title: "Your subscribers",
    mz_subs_empty_share: "No subscribers yet. Share your profile.",
    mz_subs_empty_onboard: "No subscribers yet. Complete onboarding first.",

    ca_title: "Co-analyst (revenue split)",
    ca_sub: "Designate another PRO analyst to automatically receive a % of every subscription payment you receive. Paid via Stripe Transfer from your balance.",
    ca_username_ph: "@username of co-analyst (PRO)",
    ca_pct_label: "% for co-analyst",
    ca_save: "Save",
    ca_remove: "Remove",
    ca_current: "Active co-analyst: @{name} · receives {pct}% of each payment",
    ca_none: "No co-analyst configured.",
    ca_err_404: "User not found",
    ca_err_self: "You can't be your own co-analyst",
    ca_err_pro: "Co-analyst must be PRO",
    ca_err_onboard: "Co-analyst must complete Stripe Connect onboarding",
    ca_err_invalid_pct: "% must be between 1 and 99",
    ca_transfers_title: "Recent splits",
    ca_transfers_empty: "No co-analyst payouts yet.",
    ca_transfer_sent: "Sent",
    ca_transfer_received: "Received",
    ca_transfer_failed: "Failed",
    ca_transfer_pending: "Pending",

    ls_title: "Curated lists",
    ls_login_sub: "Sign in to create and manage your trader lists.",
    ls_eyebrow: "// PHASE 3.5 · CURATED LISTS",
    ls_h1: "Your trader lists",
    ls_h1_sub: "Group traders by style, asset class or any criteria. Each list has its own feed.",
    ls_quota_hint: "Your limit: {n} (go PRO for 20).",
    ls_used: "{u}/{l} lists",
    ls_new_btn: "New list",
    ls_empty: "No lists yet. Create the first one above.",
    ls_vis_public: "Public",
    ls_vis_private: "Private",
    ls_members_count: "{n} members",
    ls_modal_title: "New list",
    ls_f_name: "Name",
    ls_f_name_ph: "Bitcoin OG, Macro Bears, …",
    ls_f_desc: "Description (optional)",
    ls_f_vis: "Visibility",
    ls_create: "Create",
    ls_confirm_delete: "Delete this list?",
    ls_err_name_short: "Name must be at least 2 characters",

    ld_not_found: "List not found or private",
    ld_back_my: "// MY LISTS",
    ld_back_my_lists: "← My lists",
    ld_by: "By",
    ld_members: "Members",
    ld_member_ph: "@username",
    ld_members_empty: "No members yet.",
    ld_feed: "List feed",
    ld_feed_empty_add: "Add members to see their feed here.",
    ld_feed_empty_noposts: "Members haven't published anything yet.",
    ld_remove_confirm: "Remove from list?",

    sub_subscribed: "Subscribed",
    sub_per_month: "/mo",
    sub_failed: "Could not start subscription",

    atl_label: "Lists",
    atl_tooltip: "Add to a list",
    atl_header: "Add to list",
    atl_empty: "You have no lists.",
    atl_create: "Create one →",

    publish_ai_label: "AI Score (preview)",
    publish_ai_sub: "Powered by Claude · Does not affect your real ranking",
    publish_ai_btn: "Evaluate",
    publish_ai_busy: "Evaluating…",
    publish_ai_risks: "Key risks",
    publish_ai_min: "You need a title and at least 30 chars of analysis to preview",

    db_title: "AI Brief",
    db_takeaway: "💡 {takeaway}",

    al_title: "Price alerts",
    al_sub: "Set a target and we'll notify you as soon as price crosses it. Data via CoinGecko, refreshed every minute.",
    al_login_sub: "Create alerts and get notified when price crosses your target.",
    al_ticker: "Ticker",
    al_when: "When",
    al_target: "Target price (USD)",
    al_spot: "spot",
    al_create: "Create",
    al_my: "My alerts ({n})",
    al_empty: "No active alerts. Create the first one above.",
    al_invalid_target: "Invalid target price",
    al_above: "ABOVE",
    al_below: "BELOW",
    al_triggered: "✓ Triggered",
    al_last_spot: "Last spot",
    al_created_at: "Created",
    al_triggered_at: "Triggered",
    al_confirm_delete: "Delete this alert?",

    j_title: "Trading Journal",
    j_login_sub: "Sign in to keep your trade journal.",
    j_pro_title: "Trading Journal PRO",
    j_pro_sub: "Keep a detailed log of every trade with automatic PnL, win-rate and equity curve. PRO operators only.",
    j_pro_cta: "Go PRO",
    j_pro_busy: "Redirecting…",
    j_h1_eyebrow: "TRADING JOURNAL",
    j_h1: "Your trading diary",
    j_h1_sub: "Log every trade, close with exit price, and learn from your stats.",
    j_new: "New trade",
    j_stats_winrate: "Win rate",
    j_stats_pnl: "Total PnL",
    j_stats_avg: "Average",
    j_stats_closed: "Closed",
    j_stats_open: "Open",
    j_equity_title: "Equity curve (cumulative PnL %)",
    j_ops: "Trades ({n})",
    j_loading: "Loading…",
    j_empty: "No trades. Create the first one above.",
    j_th_ticker: "Ticker",
    j_th_side: "Side",
    j_th_entry: "Entry",
    j_th_exit: "Exit",
    j_th_pnl: "PnL %",
    j_th_date: "Date",
    j_open: "— OPEN",
    j_close_btn: "Close",
    j_close_modal_title: "New trade",
    j_f_ticker: "Ticker",
    j_f_side: "Side",
    j_f_entry: "Entry price (USD)",
    j_f_exit: "Exit price (optional)",
    j_f_size: "Size (USD)",
    j_f_notes: "Notes (optional)",
    j_f_notes_ph: "Setup, key levels, risk management...",
    j_f_lesson: "Lesson learned (optional)",
    j_f_lesson_ph: "What did you learn from this trade?",
    j_f_save: "Save",
    j_f_cancel: "Cancel",
    j_f_exit_invalid: "Invalid entry price",
    j_confirm_delete: "Delete this journal entry?",

    m_title: "AI Mentor",
    m_login_sub: "Sign in to chat with your trading mentor.",
    m_new: "New session",
    m_empty: "No sessions yet.",
    m_quota_pro: "PRO · unlimited",
    m_quota_used: "{u}/{l} today",
    m_examples: "Ask anything. Examples:",
    m_ex1: "How do I size my position with ATR?",
    m_ex2: "Review this setup: BTC 4H, OB at 92k…",
    m_ex3: "What should I do after 3 stops in a row?",
    m_thinking: "thinking…",
    m_input_ph: "Ask your mentor… (Enter to send, Shift+Enter for new line)",
    m_role: "MENTOR",
    m_confirm_delete: "Delete this session?",
    m_err_session: "Could not start the session",
    m_err_default: "Mentor error",

    t_login_sub: "Sign in to see your balance and redemptions.",
    t_eyebrow: "$REBEL TOKENS",
    t_h1: "Your RE₿EL economy",
    t_h1_sub: "Virtual tokens you earn from activity and redeem for rewards. On-chain migration planned for PHASE 5.",
    t_balance: "Current balance",
    t_total: "Lifetime total",
    t_how_to_earn: "How to earn",
    t_e_publish: "📝 Publish analysis · +10",
    t_e_react: "❤️ Receive reaction · +1",
    t_e_correct: "✅ Direction correct · +50",
    t_e_referral: "🤝 Verified referral · +100",
    t_redeem: "Redeem your tokens",
    t_redeem_btn: "Redeem",
    t_redeem_ok: "Redemption complete",
    t_redeem_active: "Active until {when}",
    t_history: "History ({n})",
    t_history_empty: "No activity. Publish an analysis to earn your first tokens.",
    t_r_publish: "📝 Publish analysis",
    t_r_reaction: "❤️ Receive reaction",
    t_r_direction: "✅ Direction correct",
    t_r_referral: "🤝 Verified referral",

    oc_title: "On-chain $REBEL (Base L2)",
    oc_contract_link: "contract ↗",
    oc_sub: "Convert your virtual balance to on-chain $REBEL (1:1, Base L2). Gas covered by the platform.",
    oc_wallet: "Your wallet (0x...)",
    oc_balance: "On-chain",
    oc_amount: "Amount to convert",
    oc_convert: "Convert",
    oc_invalid_wallet: "Invalid wallet",
    oc_invalid_amount: "Invalid amount",
    oc_insufficient: "Insufficient virtual balance",
    oc_failed: "Conversion failed",
    oc_success: "✓ {n} $REBEL sent on-chain",
    oc_view_tx: "View tx on BaseScan",

    pill_tooltip: "{n} $REBEL · View economy",

    oc_connect: "Connect wallet",
    oc_connecting: "Connecting…",
    oc_connected: "Connected",
    oc_disconnect: "Disconnect",
    oc_no_wallet: "No wallet detected (MetaMask / Coinbase). Install an extension.",
    oc_wrong_chain: "Your wallet is not on Base L2.",
    oc_switch_chain: "Switch to Base",
    oc_choose_wallet: "Choose a wallet",

    tk_hero_eyebrow: "// BASE L2 · ERC-20 · LIVE ON-CHAIN",
    tk_hero_sub: "The native token of RE₿EL Academy and Shadow Network. Earn R₿L from your activity, redeem it for rewards, and move it on-chain to your wallet on Base L2.",
    tk_stat_price: "R₿L price",
    tk_stat_supply: "Total supply",
    tk_stat_fee: "Fee → treasury",
    tk_stat_per_swap: "per swap",
    tk_stat_liq: "DEX liquidity",
    tk_swap_title: "Buy R₿L",
    tk_swap_sub: "Swap ETH → R₿L directly from your connected wallet on Base L2. 24/7 liquidity.",
    tk_swap_chart: "View chart",
    tk_balance_label: "Your R₿L balance (RE₿EL Academy)",
    tk_balance_total: "Lifetime total:",
    tk_how_earn_title: "How to earn R₿L",
    tk_login_sub: "Sign in to see your R₿L balance and redeem rewards.",
    tk_redeem_title: "Redeem R₿L",
    tk_redeem_btn: "Redeem",
    tk_redeem_ok: "Redemption complete",
    tk_redeem_active: "Active until {when}",
    tk_history_title: "History",
    tk_history_empty: "No activity yet. Publish an analysis to earn your first R₿L.",
    tk_def_coupon_name: "🛒 Store discount",
    tk_def_coupon_desc: "-5€ coupon redeemable at the RE₿EL Academy store.",
    tk_def_boost_name: "🚀 Feed boost 24h",
    tk_def_boost_desc: "Your next analysis is featured for 24h on Shadow Network.",
    tk_def_badge_name: "🎖️ Veteran badge",
    tk_def_badge_desc: "Permanent 'Veteran' badge on your RE₿EL profile. Single-use.",
    tk_roadmap_title: "R₿L roadmap",
    tk_phase1_title: "Phase 1 — Completed",
    tk_phase1_i1: "Deploy ERC-20 RE₿EL (R₿L) on Base L2 via Thirdweb",
    tk_phase1_i2: "Active bonding curve — dynamic pricing",
    tk_phase1_i3: "Treasury wallet funded",
    tk_phase1_i4: "Off-chain ledger live on RE₿EL Academy",
    tk_phase1_i5: "Earning rates: publish +10 · reaction +1 · correct +50 · referral +100",
    tk_phase2_title: "Phase 2 — Completed",
    tk_phase2_i1: "R₿L counter in navbar · redemptions (store discount, feed boost, Veteran badge)",
    tk_phase2_i2: "Shadow Network: analyses, polls, reposts, mentions, USDC tips, co-sign, curated lists",
    tk_phase2_i3: "AI Mentor Claude (FREE 10 msgs/day · PRO unlimited) · Trading Journal PRO · Price alerts",
    tk_phase2_i4: "Premium signals + analyst subscriptions via Stripe Connect (80/20 split)",
    tk_phase2_i5: "Weekly challenges with XP + level system (Rookie · Trader · Shadow · Legend)",
    tk_phase3_title: "Phase 3 — Completed (on-chain + Web3)",
    tk_phase3_i1: "Virtual → on-chain conversion 1:1 with treasury verification (Base L2)",
    tk_phase3_i2: "Dual ledger: off-chain + on-chain running in parallel",
    tk_phase3_i3: "EIP-1193 Wallet Connect (MetaMask + Coinbase) with auto-switch to Base",
    tk_phase3_i4: "Co-analyst split (F5.5): automatic Stripe Transfer to co-signer post-payment",
    tk_phase3_i5: "AI Mentor with history, live candle chart (DexScreener · TradingView)",
    tk_phase4_title: "Phase 4 — Completed (liquidity & listings)",
    tk_phase4_i1: "Uniswap (Base) — listed and live",
    tk_phase4_i2: "ETH/R₿L liquidity pool on Uniswap — active",
    tk_phase4_i3: "Aerodrome Finance (Base-native DEX) — listed",
    tk_phase4_i4: "PancakeSwap (Base) — listed",
    tk_phase4_i5: "CoinGecko + CoinMarketCap — listing live",
    tk_phase4_i6: "Active market maker + snapshot/claim for early holders",
    tk_phase5_title: "Phase 5 — Completed (Full RE₿EL ecosystem)",
    tk_phase5_i1: "Governance: RE₿EL community voting with R₿L",
    tk_phase5_i2: "Airdrop to RE₿EL Proof™ diploma holders",
    tk_phase5_i3: "R₿L as access to courses and PRO memberships on RE₿EL Academy",
    tk_phase5_i4: "Copy Simulator with R₿L",
    tk_phase5_i5: "TrendIA integration — analyses with R₿L",
    tk_phase6_title: "Phase 6 — Advanced Token Economy",
    tk_phase6_i1: "R₿L Vault — yield sharing with academy revenue · 20% of every PRO payment goes to the Vault · monthly distribution",
    tk_phase6_i2: "Mechanical R₿L burning — 5% of every PRO payment permanently burned · deflationary supply",
    tk_phase6_i3: "Native Swap Widget on rebelbtc.com — buy R₿L directly on the platform · Uniswap V3 Base",
    tk_phase6_i4: "Real-time tokenomics dashboard — price · market cap · holders · 24h volume · locked LP",
    tk_phase6_i5: "Promo banners 50% PRO discount with R₿L — visible platform-wide for non-PRO users",
    tk_phase6_i6: "CoinGecko listing — application submitted · review in 10-20 business days",
    tk_phase6_i7: "CoinMarketCap listing — application submitted · ticket #1372525",
    tk_phase7_title: "Phase 7 — Ecosystem expansion",
    tk_phase7_i1: "RE₿EL Wallet — branded mobile app (iOS + Android)",
    tk_phase7_i2: "Trading tournaments with R₿L prizes",
    tk_phase7_i3: "RE₿EL Mentors — analysts get paid in R₿L",
    tk_phase7_i4: "Tokenized live classes with R₿L entry",
    tk_phase7_i5: "NFT Achievement Badges for milestones",
    tk_phase7_i6: "RE₿EL DAO — full on-chain governance",
    tk_phase7_i7: "CEX listing (MEXC, Gate.io, BitMart)",
    tk_phase7_i8: "Full TrendIA integration on the platform",

    common_back: "// SHADOW NETWORK",
    common_login: "Sign in",
    common_loading: "Loading…",
    common_save: "Save",
    common_cancel: "Cancel",
  },

  sk: {
    sw_title: "Globálny sentiment",
    sw_sub: "Na základe {n} dnešných analýz",
    sw_bullish: "Býčí",
    sw_bearish: "Medvedí",
    sw_neutral: "Neutrálny",
    sw_empty: "Dnes ešte žiadne dáta sentimentu",

    poll_first_to_vote: "Buď prvý hlasujúci",
    poll_votes_one: "{n} hlas",
    poll_votes_other: "{n} hlasov",
    poll_you_voted: " · Hlasoval si ✓",
    publish_poll_label: "Anketa",
    publish_poll_pro: "PRO",
    publish_poll_q_ph: "Prelomí BTC tento týždeň 100k$?",
    publish_poll_opt_ph: "Možnosť {n}",
    publish_poll_add: "+ Pridať možnosť ({n}/4)",

    tip_btn: "Tip",
    tip_modal_eyebrow: "USDC prepitné",
    tip_modal_title: "Podpor {name}",
    tip_modal_sub: "Wallet-to-wallet, 0% provízia. Preferovaná sieť: Base L2.",

    premium_lock_title: "Prémiový signál",
    premium_lock_sub: "Prihlás sa na odber @{u} aby si videl celý setup.",
    premium_lock_cta: "Prihlásiť sa →",
    publish_premium_label: "Prémiový signál",
    publish_premium_sub: "Iba odberatelia uvidia celý setup",

    publish_coauth_label: "Spolu-podpísať analýzu",
    publish_coauth_sub: "Pozvi iného analytika (musí prijať)",
    publish_coauth_ph: "@username spolu-analytika (PRO)",
    publish_coauth_sent: "✓ Pozvánka odoslaná. Čaká sa na prijatie.",
    publish_coauth_err: "Pozvanie zlyhalo (existuje PRO používateľ?).",

    repost_done: "Repostnuté",
    repost_action: "Repostnúť",

    mz_title: "Monetizuj svoju analýzu",
    mz_login_sub: "Prihlás sa.",
    mz_pro_sub: "Iba pre PRO.",
    mz_eyebrow: "// FÁZA 3 · MONETIZÁCIA",
    mz_h1_sub: "Pripoj svoj Stripe účet, nastav mesačnú cenu a fakturuj svojich sledovateľov priamo. Platforma si necháva 20%.",
    mz_connect_title: "Stripe Connect účet",
    mz_stat_account_id: "Account ID",
    mz_stat_onboarded: "Onboardnutý",
    mz_stat_charges: "Charges",
    mz_stat_payouts: "Payouts",
    mz_yes: "Áno",
    mz_no: "Nie",
    mz_active: "Aktívne",
    mz_ready: "Pripravené",
    mz_onboard_btn: "Začať onboarding",
    mz_onboard_update: "Aktualizovať onboarding",
    mz_onboard_err: "Chyba pri spustení onboardingu",
    mz_price_title: "Tvoja mesačná cena",
    mz_price_sub: "Medzi €1 a €200. Dostaneš 80% — platforma si necháva 20%.",
    mz_price_per_month: "/mes.",
    mz_price_invalid: "Cena medzi €1 a €200",
    mz_price_save_err: "Chyba ukladania",
    mz_subs_title: "Tvoji odberatelia",
    mz_subs_empty_share: "Zatiaľ žiadni odberatelia. Zdieľaj svoj profil.",
    mz_subs_empty_onboard: "Zatiaľ žiadni odberatelia. Dokonči najprv onboarding.",

    ca_title: "Spolu-analytik (rozdelenie príjmov)",
    ca_sub: "Označ iného PRO analytika, ktorý automaticky dostane % z každej platby za odber. Vyplatené cez Stripe Transfer z tvojho balansu.",
    ca_username_ph: "@username spolu-analytika (PRO)",
    ca_pct_label: "% pre spolu-analytika",
    ca_save: "Uložiť",
    ca_remove: "Odstrániť",
    ca_current: "Aktívny spolu-analytik: @{name} · dostáva {pct}% z každej platby",
    ca_none: "Žiadny spolu-analytik.",
    ca_err_404: "Používateľ neexistuje",
    ca_err_self: "Nemôžeš byť svoj vlastný spolu-analytik",
    ca_err_pro: "Spolu-analytik musí byť PRO",
    ca_err_onboard: "Spolu-analytik musí dokončiť Stripe Connect onboarding",
    ca_err_invalid_pct: "% musí byť medzi 1 a 99",
    ca_transfers_title: "Posledné splity",
    ca_transfers_empty: "Zatiaľ žiadne výplaty spolu-analytikovi.",
    ca_transfer_sent: "Odoslané",
    ca_transfer_received: "Prijaté",
    ca_transfer_failed: "Zlyhalo",
    ca_transfer_pending: "Čaká",

    ls_title: "Kurátorované zoznamy",
    ls_login_sub: "Prihlás sa pre vytvorenie a správu tvojich zoznamov operátorov.",
    ls_eyebrow: "// FÁZA 3.5 · KURÁTOROVANÉ ZOZNAMY",
    ls_h1: "Tvoje zoznamy operátorov",
    ls_h1_sub: "Zoskupuj traderov podľa štýlu, asset class alebo akéhokoľvek kritéria. Každý zoznam má vlastný feed.",
    ls_quota_hint: "Tvoj limit: {n} (PRO pre 20).",
    ls_used: "{u}/{l} zoznamov",
    ls_new_btn: "Nový zoznam",
    ls_empty: "Zatiaľ žiadne zoznamy. Vytvor prvý vyššie.",
    ls_vis_public: "Verejný",
    ls_vis_private: "Súkromný",
    ls_members_count: "{n} členov",
    ls_modal_title: "Nový zoznam",
    ls_f_name: "Názov",
    ls_f_name_ph: "Bitcoin OG, Macro Bears, …",
    ls_f_desc: "Popis (voliteľné)",
    ls_f_vis: "Viditeľnosť",
    ls_create: "Vytvoriť",
    ls_confirm_delete: "Zmazať tento zoznam?",
    ls_err_name_short: "Názov musí mať aspoň 2 znaky",

    ld_not_found: "Zoznam neexistuje alebo je súkromný",
    ld_back_my: "// MOJE ZOZNAMY",
    ld_back_my_lists: "← Moje zoznamy",
    ld_by: "Od",
    ld_members: "Členovia",
    ld_member_ph: "@username",
    ld_members_empty: "Zatiaľ žiadni členovia.",
    ld_feed: "Feed zoznamu",
    ld_feed_empty_add: "Pridaj členov, aby si videl ich feed tu.",
    ld_feed_empty_noposts: "Členovia zatiaľ nič nezverejnili.",
    ld_remove_confirm: "Odstrániť zo zoznamu?",

    sub_subscribed: "Odoberateľ",
    sub_per_month: "/mes.",
    sub_failed: "Nepodarilo sa spustiť odber",

    atl_label: "Zoznamy",
    atl_tooltip: "Pridať do zoznamu",
    atl_header: "Pridať do zoznamu",
    atl_empty: "Nemáš žiadne zoznamy.",
    atl_create: "Vytvoriť →",

    publish_ai_label: "AI Score (náhľad)",
    publish_ai_sub: "Pohon Claude · Neovplyvňuje tvoj reálny ranking",
    publish_ai_btn: "Vyhodnotiť",
    publish_ai_busy: "Vyhodnocuje sa…",
    publish_ai_risks: "Kľúčové riziká",
    publish_ai_min: "Potrebuješ titul a aspoň 30 znakov analýzy pre náhľad",

    db_title: "AI brífing",
    db_takeaway: "💡 {takeaway}",

    al_title: "Cenové upozornenia",
    al_sub: "Nastav cieľ a upozorníme ťa, keď ho cena prekročí. Dáta cez CoinGecko, obnova každú minútu.",
    al_login_sub: "Vytvor upozornenia a dostaň notifikáciu, keď cena prekročí tvoj cieľ.",
    al_ticker: "Symbol",
    al_when: "Kedy",
    al_target: "Cieľová cena (USD)",
    al_spot: "spot",
    al_create: "Vytvoriť",
    al_my: "Moje upozornenia ({n})",
    al_empty: "Žiadne aktívne upozornenia. Vytvor prvé vyššie.",
    al_invalid_target: "Neplatná cieľová cena",
    al_above: "NAD",
    al_below: "POD",
    al_triggered: "✓ Spustené",
    al_last_spot: "Posledný spot",
    al_created_at: "Vytvorené",
    al_triggered_at: "Spustené",
    al_confirm_delete: "Zmazať toto upozornenie?",

    j_title: "Obchodný denník",
    j_login_sub: "Prihlás sa a veď si denník obchodov.",
    j_pro_title: "Obchodný denník PRO",
    j_pro_sub: "Veď si detailný záznam každého obchodu s automatickým výpočtom PnL, win-rate a equity krivky. Iba pre PRO operátorov.",
    j_pro_cta: "Staň sa PRO",
    j_pro_busy: "Presmerovanie…",
    j_h1_eyebrow: "OBCHODNÝ DENNÍK",
    j_h1: "Tvoj obchodný denník",
    j_h1_sub: "Zaznamenaj každý obchod, uzavri s výstupnou cenou a uč sa zo svojej štatistiky.",
    j_new: "Nový obchod",
    j_stats_winrate: "Win-rate",
    j_stats_pnl: "PnL spolu",
    j_stats_avg: "Priemer",
    j_stats_closed: "Uzavreté",
    j_stats_open: "Otvorené",
    j_equity_title: "Equity krivka (kumulatívny PnL %)",
    j_ops: "Obchody ({n})",
    j_loading: "Načítava sa…",
    j_empty: "Žiadne obchody. Vytvor prvý vyššie.",
    j_th_ticker: "Symbol",
    j_th_side: "Strana",
    j_th_entry: "Vstup",
    j_th_exit: "Výstup",
    j_th_pnl: "PnL %",
    j_th_date: "Dátum",
    j_open: "— OTVORENÝ",
    j_close_btn: "Uzavrieť",
    j_close_modal_title: "Nový obchod",
    j_f_ticker: "Symbol",
    j_f_side: "Strana",
    j_f_entry: "Vstupná cena (USD)",
    j_f_exit: "Výstupná cena (voliteľné)",
    j_f_size: "Veľkosť (USD)",
    j_f_notes: "Poznámky (voliteľné)",
    j_f_notes_ph: "Setup, kľúčové úrovne, manažment...",
    j_f_lesson: "Naučená lekcia (voliteľné)",
    j_f_lesson_ph: "Čo si sa naučil z tohto obchodu?",
    j_f_save: "Uložiť",
    j_f_cancel: "Zrušiť",
    j_f_exit_invalid: "Neplatná vstupná cena",
    j_confirm_delete: "Zmazať tento záznam denníka?",

    m_title: "AI Mentor",
    m_login_sub: "Prihlás sa a píš so svojím trénerom.",
    m_new: "Nová relácia",
    m_empty: "Žiadne relácie zatiaľ.",
    m_quota_pro: "PRO · neobmedzene",
    m_quota_used: "{u}/{l} dnes",
    m_examples: "Pýtaj sa na čokoľvek. Príklady:",
    m_ex1: "Ako dimenzujem pozíciu s ATR?",
    m_ex2: "Skontroluj tento setup: BTC 4H, OB na 92k…",
    m_ex3: "Čo robiť po 3 stopách za sebou?",
    m_thinking: "premýšľa…",
    m_input_ph: "Spýtaj sa mentora… (Enter pre odoslanie, Shift+Enter nový riadok)",
    m_role: "MENTOR",
    m_confirm_delete: "Zmazať túto reláciu?",
    m_err_session: "Reláciu sa nepodarilo spustiť",
    m_err_default: "Chyba mentora",

    t_login_sub: "Prihlás sa a uvidíš svoj balance a výmeny.",
    t_eyebrow: "$REBEL TOKENY",
    t_h1: "Tvoja RE₿EL ekonomika",
    t_h1_sub: "Virtuálne tokeny získané aktivitou, vymeniteľné za odmeny. On-chain migrácia plánovaná na FÁZU 5.",
    t_balance: "Aktuálny balance",
    t_total: "Akumulované celkom",
    t_how_to_earn: "Ako zarobiť",
    t_e_publish: "📝 Publikovať analýzu · +10",
    t_e_react: "❤️ Dostať reakciu · +1",
    t_e_correct: "✅ Uhádnuť smer · +50",
    t_e_referral: "🤝 Overený referral · +100",
    t_redeem: "Vymeň si tokeny",
    t_redeem_btn: "Vymeniť",
    t_redeem_ok: "Výmena hotová",
    t_redeem_active: "Aktívne do {when}",
    t_history: "História ({n})",
    t_history_empty: "Žiadna aktivita. Publikuj analýzu pre prvé tokeny.",
    t_r_publish: "📝 Publikovať analýzu",
    t_r_reaction: "❤️ Dostať reakciu",
    t_r_direction: "✅ Uhádnuť smer",
    t_r_referral: "🤝 Overený referral",

    oc_title: "On-chain $REBEL (Base L2)",
    oc_contract_link: "kontrakt ↗",
    oc_sub: "Premeň svoj virtuálny balance na on-chain $REBEL (1:1, Base L2). Gas hradí platforma.",
    oc_wallet: "Tvoja peňaženka (0x...)",
    oc_balance: "On-chain",
    oc_amount: "Suma na premenu",
    oc_convert: "Premeniť",
    oc_invalid_wallet: "Neplatná peňaženka",
    oc_invalid_amount: "Neplatná suma",
    oc_insufficient: "Nedostatočný virtuálny balance",
    oc_failed: "Premena zlyhala",
    oc_success: "✓ {n} $REBEL odoslané on-chain",
    oc_view_tx: "Pozri tx na BaseScan",

    pill_tooltip: "{n} $REBEL · Pozri ekonomiku",

    oc_connect: "Pripojiť peňaženku",
    oc_connecting: "Pripája sa…",
    oc_connected: "Pripojené",
    oc_disconnect: "Odpojiť",
    oc_no_wallet: "Nenašli sme peňaženku (MetaMask / Coinbase). Nainštaluj rozšírenie.",
    oc_wrong_chain: "Tvoja peňaženka nie je na Base L2.",
    oc_switch_chain: "Prepnúť na Base",
    oc_choose_wallet: "Vyber peňaženku",

    tk_hero_eyebrow: "// BASE L2 · ERC-20 · ŽIVÉ ON-CHAIN",
    tk_hero_sub: "Natívny token RE₿EL Academy a Shadow Network. Získaj R₿L svojou aktivitou, vymeň ho za odmeny a presuň ho on-chain do tvojej peňaženky na Base L2.",
    tk_stat_price: "Cena R₿L",
    tk_stat_supply: "Celkový supply",
    tk_stat_fee: "Fee → treasury",
    tk_stat_per_swap: "za swap",
    tk_stat_liq: "DEX likvidita",
    tk_swap_title: "Kúp R₿L",
    tk_swap_sub: "Swap ETH → R₿L priamo z tvojej pripojenej peňaženky na Base L2. Likvidita 24/7.",
    tk_swap_chart: "Pozrieť graf",
    tk_balance_label: "Tvoj R₿L balance (RE₿EL Academy)",
    tk_balance_total: "Akumulované celkom:",
    tk_how_earn_title: "Ako zarobiť R₿L",
    tk_login_sub: "Prihlás sa, aby si videl svoj R₿L balance a vymenil odmeny.",
    tk_redeem_title: "Vymeniť R₿L",
    tk_redeem_btn: "Vymeniť",
    tk_redeem_ok: "Výmena hotová",
    tk_redeem_active: "Aktívne do {when}",
    tk_history_title: "História",
    tk_history_empty: "Žiadna aktivita. Publikuj analýzu pre prvé R₿L.",
    tk_def_coupon_name: "🛒 Zľava v obchode",
    tk_def_coupon_desc: "Kupón -5€ použiteľný v obchode RE₿EL Academy.",
    tk_def_boost_name: "🚀 Boost feedu 24h",
    tk_def_boost_desc: "Tvoja nasledujúca analýza je zvýraznená 24 hodín na Shadow Network.",
    tk_def_badge_name: "🎖️ Odznak Veterán",
    tk_def_badge_desc: "Permanentný odznak 'Veterán' na tvojom RE₿EL profile. Jednorazové.",
    tk_roadmap_title: "Roadmap R₿L",
    tk_phase1_title: "Fáza 1 — Dokončená",
    tk_phase1_i1: "Deploy ERC-20 RE₿EL (R₿L) na Base L2 cez Thirdweb",
    tk_phase1_i2: "Aktívna bonding curve — dynamická cena",
    tk_phase1_i3: "Treasury peňaženka fundovaná",
    tk_phase1_i4: "Off-chain ledger aktívny na RE₿EL Academy",
    tk_phase1_i5: "Earning rates: publikovať +10 · reakcia +1 · uhádnuť +50 · referral +100",
    tk_phase2_title: "Fáza 2 — Dokončená",
    tk_phase2_i1: "Počítadlo R₿L v navigácii · výmeny (zľava obchod, boost feed, odznak Veterán)",
    tk_phase2_i2: "Shadow Network: analýzy, polls, reposty, zmienky, USDC tips, spolu-podpisy, zoznamy",
    tk_phase2_i3: "AI Mentor Claude (FREE 10 správ/deň · PRO bez limitu) · Trading Journal PRO · Cenové upozornenia",
    tk_phase2_i4: "Prémiové signály + odbery analytikov cez Stripe Connect (split 80/20)",
    tk_phase2_i5: "Týždenné výzvy s XP + systém úrovní (Rookie · Trader · Shadow · Legenda)",
    tk_phase3_title: "Fáza 3 — Dokončená (on-chain + Web3)",
    tk_phase3_i1: "Konverzia virtuálne → on-chain 1:1 s verifikáciou treasury (Base L2)",
    tk_phase3_i2: "Dual ledger: off-chain + on-chain paralelne",
    tk_phase3_i3: "Wallet Connect EIP-1193 (MetaMask + Coinbase) s auto-prepnutím na Base",
    tk_phase3_i4: "Spolu-analytik split (F5.5): automatický Stripe Transfer po platbe",
    tk_phase3_i5: "AI Mentor s históriou, live svietnikový graf (DexScreener · TradingView)",
    tk_phase4_title: "Fáza 4 — Dokončená (likvidita & listing)",
    tk_phase4_i1: "Uniswap (Base) — listing aktívny",
    tk_phase4_i2: "Pool likvidity ETH/R₿L na Uniswape — aktívny",
    tk_phase4_i3: "Aerodrome Finance (natívny DEX Base) — listovaný",
    tk_phase4_i4: "PancakeSwap (Base) — listovaný",
    tk_phase4_i5: "Listing na CoinGecko + CoinMarketCap — aktívny",
    tk_phase4_i6: "Aktívny market maker + snapshot/claim pre raných držiteľov",
    tk_phase5_title: "Fáza 5 — Dokončená (Kompletný ekosystém RE₿EL)",
    tk_phase5_i1: "Governance: hlasovanie komunity RE₿EL s R₿L",
    tk_phase5_i2: "Airdrop pre držiteľov diplomov RE₿EL Proof™",
    tk_phase5_i3: "R₿L ako prístup ku kurzom a PRO členstvám na RE₿EL Academy",
    tk_phase5_i4: "Copy Simulator s R₿L",
    tk_phase5_i5: "Integrácia TrendIA — analýzy s R₿L",
    tk_phase6_title: "Fáza 6 — Pokročilá Token Economy",
    tk_phase6_i1: "R₿L Vault — yield sharing z príjmov akadémie · 20 % z každej PRO platby ide do Vaultu · mesačná distribúcia",
    tk_phase6_i2: "Mechanický burning R₿L — 5 % z každej PRO platby trvalo spálených · deflačný supply",
    tk_phase6_i3: "Natívny Swap Widget na rebelbtc.com — kúp R₿L priamo na platforme · Uniswap V3 Base",
    tk_phase6_i4: "Dashboard tokenomics v reálnom čase — cena · market cap · holderi · 24h objem · uzamknuté LP",
    tk_phase6_i5: "Promo bannery 50 % zľava na PRO s R₿L — viditeľné na celej platforme pre používateľov bez PRO",
    tk_phase6_i6: "Listing na CoinGecko — žiadosť odoslaná · posúdenie do 10-20 pracovných dní",
    tk_phase6_i7: "Listing na CoinMarketCap — žiadosť odoslaná · ticket #1372525",
    tk_phase7_title: "Fáza 7 — Expanzia ekosystému",
    tk_phase7_i1: "RE₿EL Wallet — mobilná appka s vlastnou značkou (iOS + Android)",
    tk_phase7_i2: "Trading turnaje s R₿L ako cenou",
    tk_phase7_i3: "RE₿EL Mentors — analytici platení v R₿L",
    tk_phase7_i4: "Tokenizované live lekcie so vstupom za R₿L",
    tk_phase7_i5: "NFT Achievement odznaky za míľniky",
    tk_phase7_i6: "RE₿EL DAO — plná on-chain governance",
    tk_phase7_i7: "Listing na CEX (MEXC, Gate.io, BitMart)",
    tk_phase7_i8: "Plná integrácia TrendIA na platforme",

    common_back: "// SHADOW NETWORK",
    common_login: "Prihlásiť sa",
    common_loading: "Načítava sa…",
    common_save: "Uložiť",
    common_cancel: "Zrušiť",
  },

  "zh-CN": {
    sw_title: "全球情绪",
    sw_sub: "基于今日{n}个分析",
    sw_bullish: "看涨",
    sw_bearish: "看跌",
    sw_neutral: "中性",
    sw_empty: "今日暂无情绪数据",
    poll_first_to_vote: "成为第一个投票的人",
    poll_votes_one: "{n}票",
    poll_votes_other: "{n}票",
    poll_you_voted: " · 您已投票 ✓",
    publish_poll_label: "投票",
    publish_poll_pro: "PRO",
    publish_poll_q_ph: "BTC本周会突破10万吗?",
    publish_poll_opt_ph: "选项{n}",
    publish_poll_add: "+ 添加选项 ({n}/4)",
    tip_btn: "打赏",
    tip_modal_eyebrow: "打赏 USDC",
    tip_modal_title: "支持{name}",
    tip_modal_sub: "钱包到钱包,0%手续费。首选网络:Base L2。",
    premium_lock_title: "高级信号",
    premium_lock_sub: "订阅@{u}查看完整设置。",
    premium_lock_cta: "订阅 →",
    publish_premium_label: "高级信号",
    publish_premium_sub: "仅订阅者可查看完整设置",
    publish_coauth_label: "共同签署分析",
    publish_coauth_sub: "邀请另一位分析师(需接受)",
    publish_coauth_ph: "共同分析师@username (PRO)",
    publish_coauth_sent: "✓ 邀请已发送。等待接受。",
    publish_coauth_err: "无法邀请(用户是否为现有PRO用户?)。",
    repost_done: "已转发",
    repost_action: "转发",
    mz_title: "变现您的分析",
    mz_login_sub: "请登录。",
    mz_pro_sub: "仅PRO可用。",
    mz_eyebrow: "// 阶段3 · 变现",
    mz_h1_sub: "连接您的Stripe账户,设定月费,直接向粉丝收费。平台收取20%。",
    mz_connect_title: "Stripe Connect账户",
    mz_stat_account_id: "Account ID",
    mz_stat_onboarded: "Onboarded",
    mz_stat_charges: "Charges",
    mz_stat_payouts: "Payouts",
    mz_yes: "是",
    mz_no: "否",
    mz_active: "活跃",
    mz_ready: "就绪",
    mz_onboard_btn: "开始入驻",
    mz_onboard_update: "更新入驻",
    mz_onboard_err: "启动入驻时出错",
    mz_price_title: "您的月费",
    mz_price_sub: "€1至€200之间。您将获得80% — 平台保留20%。",
    mz_price_per_month: "/月",
    mz_price_invalid: "价格需在€1至€200之间",
    mz_price_save_err: "保存出错",
    mz_subs_title: "您的订阅者",
    mz_subs_empty_share: "暂无订阅者。分享您的个人资料。",
    mz_subs_empty_onboard: "暂无订阅者。请先完成入驻。",
    ca_title: "共同分析师(收益分成)",
    ca_sub: "指定另一位PRO分析师自动获得您每笔订阅付款的一定百分比。通过Stripe Transfer从您的余额支付。",
    ca_username_ph: "共同分析师@username (PRO)",
    ca_pct_label: "共同分析师分成%",
    ca_save: "保存",
    ca_remove: "移除",
    ca_current: "活跃共同分析师:@{name} · 获得每笔付款的{pct}%",
    ca_none: "未配置共同分析师。",
    ca_err_404: "用户未找到",
    ca_err_self: "您不能成为自己的共同分析师",
    ca_err_pro: "共同分析师必须是PRO",
    ca_err_onboard: "共同分析师必须完成Stripe Connect入驻",
    ca_err_invalid_pct: "%需在1至99之间",
    ca_transfers_title: "最近分成",
    ca_transfers_empty: "暂无支付给共同分析师的记录。",
    ca_transfer_sent: "已发送",
    ca_transfer_received: "已接收",
    ca_transfer_failed: "失败",
    ca_transfer_pending: "待处理",
    ls_title: "精选列表",
    ls_login_sub: "登录以创建和管理您的交易员列表。",
    ls_eyebrow: "// 阶段3.5 · 精选列表",
    ls_h1: "您的交易员列表",
    ls_h1_sub: "按风格、资产类别或任何标准分组交易员。每个列表都有自己的动态。",
    ls_quota_hint: "您的限额:{n}(升级至PRO获得20个)。",
    ls_used: "{u}/{l}个列表",
    ls_new_btn: "新建列表",
    ls_empty: "您还没有列表。在上方创建第一个。",
    ls_vis_public: "公开",
    ls_vis_private: "私密",
    ls_members_count: "{n}名成员",
    ls_modal_title: "新建列表",
    ls_f_name: "名称",
    ls_f_name_ph: "Bitcoin OG, Macro Bears, …",
    ls_f_desc: "描述(可选)",
    ls_f_vis: "可见性",
    ls_create: "创建",
    ls_confirm_delete: "删除此列表?",
    ls_err_name_short: "名称至少需要2个字符",
    ld_not_found: "列表未找到或为私密",
    ld_back_my: "// 我的列表",
    ld_back_my_lists: "← 我的列表",
    ld_by: "创建者",
    ld_members: "成员",
    ld_member_ph: "@username",
    ld_members_empty: "暂无成员。",
    ld_feed: "列表动态",
    ld_feed_empty_add: "添加成员以在此查看其动态。",
    ld_feed_empty_noposts: "成员尚未发布任何内容。",
    ld_remove_confirm: "从列表中移除?",
    sub_subscribed: "已订阅",
    sub_per_month: "/月",
    sub_failed: "无法启动订阅",
    atl_label: "列表",
    atl_tooltip: "添加到列表",
    atl_header: "添加到列表",
    atl_empty: "您没有列表。",
    atl_create: "创建一个 →",
    publish_ai_label: "AI评分(预览)",
    publish_ai_sub: "由Claude提供支持 · 不影响您的实际排名",
    publish_ai_btn: "评估",
    publish_ai_busy: "评估中…",
    publish_ai_risks: "关键风险",
    publish_ai_min: "您需要标题和至少30个字符的分析才能预览",
    db_title: "AI简报",
    db_takeaway: "💡 {takeaway}",
    al_title: "价格提醒",
    al_sub: "设定目标,价格触达时我们将通知您。数据来自CoinGecko,每分钟刷新。",
    al_login_sub: "创建提醒,当价格触达您的目标时接收通知。",
    al_ticker: "代码",
    al_when: "当",
    al_target: "目标价格(USD)",
    al_spot: "现货",
    al_create: "创建",
    al_my: "我的提醒({n})",
    al_empty: "无活跃提醒。在上方创建第一个。",
    al_invalid_target: "目标价格无效",
    al_above: "ABOVE",
    al_below: "BELOW",
    al_triggered: "✓ 已触发",
    al_last_spot: "最新现货",
    al_created_at: "创建时间",
    al_triggered_at: "触发时间",
    al_confirm_delete: "删除此提醒?",
    j_title: "交易日志",
    j_login_sub: "登录以记录您的交易日志。",
    j_pro_title: "交易日志PRO",
    j_pro_sub: "详细记录每笔交易,自动计算盈亏、胜率和权益曲线。仅PRO交易员可用。",
    j_pro_cta: "成为PRO",
    j_pro_busy: "跳转中…",
    j_h1_eyebrow: "交易日志",
    j_h1: "您的交易日志",
    j_h1_sub: "记录每笔交易,以退出价格关闭,从统计数据中学习。",
    j_new: "新建交易",
    j_stats_winrate: "胜率",
    j_stats_pnl: "累计盈亏",
    j_stats_avg: "平均",
    j_stats_closed: "已平仓",
    j_stats_open: "未平仓",
    j_equity_title: "权益曲线(累计盈亏%)",
    j_ops: "交易({n})",
    j_loading: "加载中…",
    j_empty: "无交易记录。在上方创建第一个。",
    j_th_ticker: "代码",
    j_th_side: "方向",
    j_th_entry: "入场",
    j_th_exit: "退出",
    j_th_pnl: "盈亏%",
    j_th_date: "日期",
    j_open: "— 未平仓",
    j_close_btn: "关闭",
    j_close_modal_title: "新建交易",
    j_f_ticker: "代码",
    j_f_side: "方向",
    j_f_entry: "入场价格(USD)",
    j_f_exit: "退出价格(可选)",
    j_f_size: "仓位(USD)",
    j_f_notes: "备注(可选)",
    j_f_notes_ph: "设置、关键位、管理...",
    j_f_lesson: "学到的经验(可选)",
    j_f_lesson_ph: "您从此交易中学到了什么?",
    j_f_save: "保存",
    j_f_cancel: "取消",
    j_f_exit_invalid: "入场价格无效",
    j_confirm_delete: "从日志中删除此条目?",
    m_title: "AI导师",
    m_login_sub: "登录与您的交易导师对话。",
    m_new: "新建会话",
    m_empty: "暂无会话。",
    m_quota_pro: "PRO · 无限制",
    m_quota_used: "今日{u}/{l}",
    m_examples: "提出您需要的问题。示例:",
    m_ex1: "如何使用ATR调整仓位?",
    m_ex2: "审查我的这个设置:BTC 4H,OB在92k…",
    m_ex3: "连续3次止损后该怎么办?",
    m_thinking: "思考中…",
    m_input_ph: "向您的导师提问…(Enter发送,Shift+Enter换行)",
    m_role: "导师",
    m_confirm_delete: "删除此会话?",
    m_err_session: "无法启动会话",
    m_err_default: "导师错误",
    t_login_sub: "登录以查看您的余额和兑换。",
    t_eyebrow: "$REBEL代币",
    t_h1: "您的RE₿EL经济",
    t_h1_sub: "您通过活动赚取的虚拟代币,可兑换奖励。计划在第5阶段迁移至链上。",
    t_balance: "当前余额",
    t_total: "累计总计",
    t_how_to_earn: "如何赚取",
    t_e_publish: "📝 发布分析 · +10",
    t_e_react: "❤️ 收到反应 · +1",
    t_e_correct: "✅ 预测正确 · +50",
    t_e_referral: "🤝 验证推荐 · +100",
    t_redeem: "兑换您的代币",
    t_redeem_btn: "兑换",
    t_redeem_ok: "兑换完成",
    t_redeem_active: "有效期至{when}",
    t_history: "历史记录({n})",
    t_history_empty: "无活动。发布分析赚取您的首批代币。",
    t_r_publish: "📝 发布分析",
    t_r_reaction: "❤️ 收到反应",
    t_r_direction: "✅ 预测正确",
    t_r_referral: "🤝 验证推荐",
    oc_title: "链上$REBEL (Base L2)",
    oc_contract_link: "合约 ↗",
    oc_sub: "将您的虚拟余额转换为链上$REBEL(1:1,Base L2)。Gas费由平台承担。",
    oc_wallet: "您的钱包(0x...)",
    oc_balance: "链上",
    oc_amount: "转换数量",
    oc_convert: "转换",
    oc_invalid_wallet: "钱包无效",
    oc_invalid_amount: "数量无效",
    oc_insufficient: "虚拟余额不足",
    oc_failed: "转换失败",
    oc_success: "✓ {n} $REBEL已发送至链上",
    oc_view_tx: "在BaseScan查看交易",
    pill_tooltip: "{n} $REBEL · 查看经济",
    oc_connect: "连接钱包",
    oc_connecting: "连接中…",
    oc_connected: "已连接",
    oc_disconnect: "断开连接",
    oc_no_wallet: "未检测到钱包(MetaMask / Coinbase)。请安装扩展。",
    oc_wrong_chain: "您的钱包不在Base L2。",
    oc_switch_chain: "切换至Base",
    oc_choose_wallet: "选择钱包",
    tk_hero_eyebrow: "// BASE L2 · ERC-20 · 链上运行",
    tk_hero_sub: "RE₿EL Academy和Shadow Network的原生代币。通过活动赚取R₿L,兑换奖励,可在Base L2上转移至您的链上钱包。",
    tk_stat_price: "R₿L价格",
    tk_stat_supply: "总供应量",
    tk_stat_fee: "手续费 → 金库",
    tk_stat_per_swap: "每次兑换",
    tk_stat_liq: "DEX流动性",
    tk_swap_title: "购买R₿L",
    tk_swap_sub: "直接从Base L2上的已连接钱包兑换ETH → R₿L。24/7流动性。",
    tk_swap_chart: "查看图表",
    tk_balance_label: "您的R₿L余额(RE₿EL Academy)",
    tk_balance_total: "累计总计:",
    tk_how_earn_title: "如何赚取R₿L",
    tk_login_sub: "登录以查看您的R₿L余额并兑换奖励。",
    tk_redeem_title: "兑换R₿L",
    tk_redeem_btn: "兑换",
    tk_redeem_ok: "兑换完成",
    tk_redeem_active: "有效期至{when}",
    tk_history_title: "历史记录",
    tk_history_empty: "无活动。发布分析赚取您的首批R₿L。",
    tk_def_coupon_name: "🛒 商店折扣",
    tk_def_coupon_desc: "可在RE₿EL Academy商店兑换的-5€优惠券。",
    tk_def_boost_name: "🚀 动态提升24小时",
    tk_def_boost_desc: "您的下一篇分析在Shadow Network中突出显示24小时。",
    tk_def_badge_name: "🎖️ 老兵徽章",
    tk_def_badge_desc: "RE₿EL个人资料中的永久'老兵'徽章。单次使用。",
    tk_roadmap_title: "R₿L路线图",
    tk_phase1_title: "第1阶段 — 已完成",
    tk_phase1_i1: "通过Thirdweb在Base L2上部署ERC-20 RE₿EL (R₿L)",
    tk_phase1_i2: "联合曲线活跃 — 动态定价",
    tk_phase1_i3: "金库钱包已注资",
    tk_phase1_i4: "RE₿EL Academy的链下账本活跃",
    tk_phase1_i5: "收益率:发布+10 · 反应+1 · 预测正确+50 · 推荐+100",
    tk_phase2_title: "第2阶段 — 已完成",
    tk_phase2_i1: "导航栏R₿L计数器 · 兑换(商店折扣、动态提升、老兵徽章)",
    tk_phase2_i2: "Shadow Network:分析、投票、转发、提及、USDC打赏、共同签署、精选列表",
    tk_phase2_i3: "Claude AI导师(FREE 10条/天 · PRO无限制) · 交易日志PRO · 价格提醒",
    tk_phase2_i4: "高级信号 + 通过Stripe Connect订阅分析师(80/20分成)",
    tk_phase2_i5: "每周挑战获得XP + 等级系统(Rookie · Trader · Shadow · Legend)",
    tk_phase3_title: "第3阶段 — 已完成(链上 + Web3)",
    tk_phase3_i1: "虚拟 → 链上1:1转换,金库验证(Base L2)",
    tk_phase3_i2: "双重账本:链下 + 链上并行运行",
    tk_phase3_i3: "Wallet Connect EIP-1193 (MetaMask + Coinbase),自动切换至Base",
    tk_phase3_i4: "共同分析师分成(F5.5):付款后自动Stripe Transfer给共同签署者",
    tk_phase3_i5: "带历史记录的AI导师,实时蜡烛图(DexScreener · TradingView)",
    tk_phase4_title: "第4阶段 — 已完成(流动性与上架)",
    tk_phase4_i1: "Uniswap (Base) — 已上架且运行",
    tk_phase4_i2: "Uniswap上的ETH/R₿L流动性池 — 活跃",
    tk_phase4_i3: "Aerodrome Finance (Base原生DEX) — 已上架",
    tk_phase4_i4: "PancakeSwap (Base) — 已上架",
    tk_phase4_i5: "CoinGecko + CoinMarketCap — 上架活跃",
    tk_phase4_i6: "做市商活跃 + 早期持有者快照/领取",
    tk_phase5_title: "第5阶段 — 已完成(完整RE₿EL生态系统)",
    tk_phase5_i1: "治理:RE₿EL社区用R₿L投票",
    tk_phase5_i2: "空投给RE₿EL Proof™文凭持有者",
    tk_phase5_i3: "R₿L作为RE₿EL Academy课程和PRO会员的访问权",
    tk_phase5_i4: "带R₿L的跟单模拟器",
    tk_phase5_i5: "TrendIA集成 — 用R₿L分析",
    tk_phase6_title: "第6阶段 — 高级代币经济",
    tk_phase6_i1: "R₿L金库 — 与学院收入分享收益 · 每笔PRO付款的20%进入金库 · 每月分配",
    tk_phase6_i2: "R₿L机制性销毁 — 每笔PRO付款的5%永久销毁 · 通缩供应",
    tk_phase6_i3: "rebelbtc.com原生兑换小部件 — 直接在平台购买R₿L · Uniswap V3 Base",
    tk_phase6_i4: "实时代币经济仪表板 — 价格 · 市值 · 持有者 · 24小时交易量 · LP锁定",
    tk_phase6_i5: "用R₿L享受50%折扣PRO的推广横幅 — 对非PRO用户在整个平台可见",
    tk_phase6_i6: "CoinGecko上架 — 申请已提交 · 10-20个工作日内审核",
    tk_phase6_i7: "CoinMarketCap上架 — 申请已提交 · 工单#1372525",
    tk_phase7_title: "第7阶段 — 生态系统扩展",
    tk_phase7_i1: "RE₿EL Wallet — 自有品牌移动应用(iOS + Android)",
    tk_phase7_i2: "以R₿L为奖励的交易锦标赛",
    tk_phase7_i3: "RE₿EL Mentors — 分析师用R₿L收费",
    tk_phase7_i4: "用R₿L入场的代币化实时课程",
    tk_phase7_i5: "里程碑成就NFT徽章",
    tk_phase7_i6: "RE₿EL DAO — 完整链上治理",
    tk_phase7_i7: "CEX上架(MEXC, Gate.io, BitMart)",
    tk_phase7_i8: "TrendIA在平台的完整集成",
    common_back: "// SHADOW NETWORK",
    common_login: "登录",
    common_loading: "加载中…",
    common_save: "保存",
    common_cancel: "取消",
  },

  de: {
    sw_title: "Globales Sentiment",
    sw_sub: "Basierend auf {n} Analysen von heute",
    sw_bullish: "Bullisch",
    sw_bearish: "Bearisch",
    sw_neutral: "Neutral",
    sw_empty: "Heute noch kein Sentiment",
    poll_first_to_vote: "Sei der Erste, der abstimmt",
    poll_votes_one: "{n} Stimme",
    poll_votes_other: "{n} Stimmen",
    poll_you_voted: " · Du hast abgestimmt ✓",
    publish_poll_label: "Umfrage",
    publish_poll_pro: "PRO",
    publish_poll_q_ph: "Wird BTC diese Woche die 100k durchbrechen?",
    publish_poll_opt_ph: "Option {n}",
    publish_poll_add: "+ Option hinzufügen ({n}/4)",
    tip_btn: "Tip",
    tip_modal_eyebrow: "USDC-Tip",
    tip_modal_title: "Unterstütze {name}",
    tip_modal_sub: "Wallet-to-wallet, 0% Gebühr. Bevorzugtes Netzwerk: Base L2.",
    premium_lock_title: "Premium-Signal",
    premium_lock_sub: "Abonniere @{u}, um das vollständige Setup zu sehen.",
    premium_lock_cta: "Abonnieren →",
    publish_premium_label: "Premium-Signal",
    publish_premium_sub: "Nur Abonnenten sehen das vollständige Setup",
    publish_coauth_label: "Analyse co-signieren",
    publish_coauth_sub: "Anderen Analysten einladen (muss akzeptieren)",
    publish_coauth_ph: "@username des Co-Analysten (PRO)",
    publish_coauth_sent: "✓ Einladung gesendet. Warte auf Annahme.",
    publish_coauth_err: "Einladung fehlgeschlagen (existierender PRO-User?).",
    repost_done: "Repostet",
    repost_action: "Reposten",
    mz_title: "Monetarisiere deine Analyse",
    mz_login_sub: "Melde dich an.",
    mz_pro_sub: "Nur für PRO verfügbar.",
    mz_eyebrow: "// PHASE 3 · MONETARISIERUNG",
    mz_h1_sub: "Verbinde dein Stripe-Konto, lege deinen monatlichen Preis fest und kassiere direkt von deinen Followern. Die Plattform behält 20%.",
    mz_connect_title: "Stripe Connect Konto",
    mz_stat_account_id: "Account ID",
    mz_stat_onboarded: "Onboarded",
    mz_stat_charges: "Charges",
    mz_stat_payouts: "Payouts",
    mz_yes: "Ja",
    mz_no: "Nein",
    mz_active: "Aktiv",
    mz_ready: "Bereit",
    mz_onboard_btn: "Onboarding starten",
    mz_onboard_update: "Onboarding aktualisieren",
    mz_onboard_err: "Fehler beim Starten des Onboardings",
    mz_price_title: "Dein monatlicher Preis",
    mz_price_sub: "Zwischen €1 und €200. Du erhältst 80% — die Plattform behält 20%.",
    mz_price_per_month: "/Monat",
    mz_price_invalid: "Preis zwischen €1 und €200",
    mz_price_save_err: "Fehler beim Speichern",
    mz_subs_title: "Deine Abonnenten",
    mz_subs_empty_share: "Noch keine Abonnenten. Teile dein Profil.",
    mz_subs_empty_onboard: "Noch keine Abonnenten. Schließe zuerst das Onboarding ab.",
    ca_title: "Co-Analyst (Revenue Split)",
    ca_sub: "Bestimme einen anderen PRO-Analysten, der automatisch einen % jeder Abo-Zahlung erhält, die du bekommst. Zahlung via Stripe Transfer von deinem Balance.",
    ca_username_ph: "@username des Co-Analysten (PRO)",
    ca_pct_label: "% für Co-Analyst",
    ca_save: "Speichern",
    ca_remove: "Entfernen",
    ca_current: "Aktiver Co-Analyst: @{name} · erhält {pct}% jeder Zahlung",
    ca_none: "Kein Co-Analyst konfiguriert.",
    ca_err_404: "User nicht gefunden",
    ca_err_self: "Du kannst nicht dein eigener Co-Analyst sein",
    ca_err_pro: "Co-Analyst muss PRO sein",
    ca_err_onboard: "Co-Analyst muss Stripe Connect Onboarding abschließen",
    ca_err_invalid_pct: "% muss zwischen 1 und 99 liegen",
    ca_transfers_title: "Neueste Splits",
    ca_transfers_empty: "Noch keine Zahlungen an Co-Analyst.",
    ca_transfer_sent: "Gesendet",
    ca_transfer_received: "Erhalten",
    ca_transfer_failed: "Fehlgeschlagen",
    ca_transfer_pending: "Ausstehend",
    ls_title: "Kuratierte Listen",
    ls_login_sub: "Melde dich an, um deine Trader-Listen zu erstellen und zu verwalten.",
    ls_eyebrow: "// PHASE 3.5 · KURATIERTE LISTEN",
    ls_h1: "Deine Trader-Listen",
    ls_h1_sub: "Gruppiere Trader nach Stil, Asset Class oder jedem anderen Kriterium. Jede Liste hat ihren eigenen Feed.",
    ls_quota_hint: "Dein Limit: {n} (upgrade auf PRO für 20).",
    ls_used: "{u}/{l} Listen",
    ls_new_btn: "Neue Liste",
    ls_empty: "Du hast noch keine Listen. Erstelle die erste oben.",
    ls_vis_public: "Öffentlich",
    ls_vis_private: "Privat",
    ls_members_count: "{n} Mitglieder",
    ls_modal_title: "Neue Liste",
    ls_f_name: "Name",
    ls_f_name_ph: "Bitcoin OG, Macro Bears, …",
    ls_f_desc: "Beschreibung (optional)",
    ls_f_vis: "Sichtbarkeit",
    ls_create: "Erstellen",
    ls_confirm_delete: "Diese Liste löschen?",
    ls_err_name_short: "Name muss mindestens 2 Zeichen haben",
    ld_not_found: "Liste nicht gefunden oder privat",
    ld_back_my: "// MEINE LISTEN",
    ld_back_my_lists: "← Meine Listen",
    ld_by: "Von",
    ld_members: "Mitglieder",
    ld_member_ph: "@username",
    ld_members_empty: "Noch keine Mitglieder.",
    ld_feed: "Listen-Feed",
    ld_feed_empty_add: "Füge Mitglieder hinzu, um ihren Feed hier zu sehen.",
    ld_feed_empty_noposts: "Die Mitglieder haben noch nichts gepostet.",
    ld_remove_confirm: "Von der Liste entfernen?",
    sub_subscribed: "Abonniert",
    sub_per_month: "/Monat",
    sub_failed: "Abo konnte nicht gestartet werden",
    atl_label: "Listen",
    atl_tooltip: "Zu einer Liste hinzufügen",
    atl_header: "Zu Liste hinzufügen",
    atl_empty: "Du hast keine Listen.",
    atl_create: "Eine erstellen →",
    publish_ai_label: "KI-Score (Vorschau)",
    publish_ai_sub: "Powered by Claude · Beeinflusst nicht dein echtes Ranking",
    publish_ai_btn: "Bewerten",
    publish_ai_busy: "Bewerte…",
    publish_ai_risks: "Hauptrisiken",
    publish_ai_min: "Du brauchst einen Titel und mindestens 30 Zeichen Analyse für die Vorschau",
    db_title: "KI-Brief",
    db_takeaway: "💡 {takeaway}",
    al_title: "Preis-Alerts",
    al_sub: "Setze ein Ziel und wir benachrichtigen dich, sobald der Preis es erreicht. Daten via CoinGecko, Update jede Minute.",
    al_login_sub: "Erstelle Alerts und erhalte eine Benachrichtigung, wenn der Preis dein Ziel erreicht.",
    al_ticker: "Ticker",
    al_when: "Wenn",
    al_target: "Zielpreis (USD)",
    al_spot: "Spot",
    al_create: "Erstellen",
    al_my: "Meine Alerts ({n})",
    al_empty: "Keine aktiven Alerts. Erstelle den ersten oben.",
    al_invalid_target: "Ungültiger Zielpreis",
    al_above: "ABOVE",
    al_below: "BELOW",
    al_triggered: "✓ Ausgelöst",
    al_last_spot: "Letzter Spot",
    al_created_at: "Erstellt",
    al_triggered_at: "Ausgelöst",
    al_confirm_delete: "Diesen Alert löschen?",
    j_title: "Trading Journal",
    j_login_sub: "Melde dich an, um dein Trading-Tagebuch zu führen.",
    j_pro_title: "Trading Journal PRO",
    j_pro_sub: "Führe ein detailliertes Protokoll jedes Trades mit automatischer Berechnung von PnL, Win-Rate und Equity-Kurve. Nur für PRO-Trader verfügbar.",
    j_pro_cta: "Werde PRO",
    j_pro_busy: "Leite um…",
    j_h1_eyebrow: "TRADING JOURNAL",
    j_h1: "Dein Trading-Tagebuch",
    j_h1_sub: "Notiere jeden Trade, schließe mit dem Exit-Preis und lerne aus deiner Statistik.",
    j_new: "Neue Operation",
    j_stats_winrate: "Win-Rate",
    j_stats_pnl: "PnL kumuliert",
    j_stats_avg: "Durchschnitt",
    j_stats_closed: "Geschlossen",
    j_stats_open: "Offen",
    j_equity_title: "Equity-Kurve (kumuliertes PnL %)",
    j_ops: "Operationen ({n})",
    j_loading: "Lade…",
    j_empty: "Keine Operationen. Erstelle die erste oben.",
    j_th_ticker: "Ticker",
    j_th_side: "Side",
    j_th_entry: "Entry",
    j_th_exit: "Exit",
    j_th_pnl: "PnL %",
    j_th_date: "Datum",
    j_open: "— OFFEN",
    j_close_btn: "Schließen",
    j_close_modal_title: "Neue Operation",
    j_f_ticker: "Ticker",
    j_f_side: "Side",
    j_f_entry: "Entry Price (USD)",
    j_f_exit: "Exit Price (optional)",
    j_f_size: "Größe (USD)",
    j_f_notes: "Notizen (optional)",
    j_f_notes_ph: "Setup, Schlüssellevel, Management...",
    j_f_lesson: "Gelernte Lektion (optional)",
    j_f_lesson_ph: "Was hast du aus dieser Operation gelernt?",
    j_f_save: "Speichern",
    j_f_cancel: "Abbrechen",
    j_f_exit_invalid: "Ungültiger Entry-Preis",
    j_confirm_delete: "Diesen Journal-Eintrag löschen?",
    m_title: "KI-Mentor",
    m_login_sub: "Melde dich an, um mit deinem Trading-Mentor zu sprechen.",
    m_new: "Neue Session",
    m_empty: "Noch keine Sessions.",
    m_quota_pro: "PRO · unbegrenzt",
    m_quota_used: "{u}/{l} heute",
    m_examples: "Frag, was du brauchst. Beispiele:",
    m_ex1: "Wie dimensioniere ich meine Position mit ATR?",
    m_ex2: "Check mir dieses Setup: BTC 4H, OB bei 92k…",
    m_ex3: "Was mache ich nach 3 Stops hintereinander?",
    m_thinking: "denke nach…",
    m_input_ph: "Frag deinen Mentor… (Enter zum Senden, Shift+Enter Zeilenumbruch)",
    m_role: "MENTOR",
    m_confirm_delete: "Diese Session löschen?",
    m_err_session: "Session konnte nicht gestartet werden",
    m_err_default: "Mentor-Fehler",
    t_login_sub: "Melde dich an, um dein Guthaben und Einlösungen zu sehen.",
    t_eyebrow: "$REBEL TOKENS",
    t_h1: "Deine RE₿EL-Ökonomie",
    t_h1_sub: "Virtuelle Tokens, die du mit deiner Aktivität verdienst und gegen Belohnungen eintauschst. On-chain-Migration für PHASE 5 geplant.",
    t_balance: "Aktuelles Guthaben",
    t_total: "Kumuliert gesamt",
    t_how_to_earn: "Wie verdienen",
    t_e_publish: "📝 Analyse veröffentlichen · +10",
    t_e_react: "❤️ Reaktion erhalten · +1",
    t_e_correct: "✅ Richtung richtig · +50",
    t_e_referral: "🤝 Verifizierter Referral · +100",
    t_redeem: "Tausche deine Tokens ein",
    t_redeem_btn: "Einlösen",
    t_redeem_ok: "Einlösung durchgeführt",
    t_redeem_active: "Aktiv bis {when}",
    t_history: "Verlauf ({n})",
    t_history_empty: "Keine Aktivität. Veröffentliche eine Analyse, um deine ersten Tokens zu verdienen.",
    t_r_publish: "📝 Analyse veröffentlichen",
    t_r_reaction: "❤️ Reaktion erhalten",
    t_r_direction: "✅ Richtung richtig",
    t_r_referral: "🤝 Verifizierter Referral",
    oc_title: "On-chain $REBEL (Base L2)",
    oc_contract_link: "Vertrag ↗",
    oc_sub: "Konvertiere dein virtuelles Guthaben in $REBEL on-chain (1:1, Base L2). Gas-Tx wird von der Plattform übernommen.",
    oc_wallet: "Deine Wallet (0x...)",
    oc_balance: "On-chain",
    oc_amount: "Zu konvertierende Menge",
    oc_convert: "Konvertieren",
    oc_invalid_wallet: "Ungültige Wallet",
    oc_invalid_amount: "Ungültige Menge",
    oc_insufficient: "Unzureichendes virtuelles Guthaben",
    oc_failed: "Konvertierung fehlgeschlagen",
    oc_success: "✓ {n} $REBEL on-chain gesendet",
    oc_view_tx: "Tx auf BaseScan anzeigen",
    pill_tooltip: "{n} $REBEL · Ökonomie anzeigen",
    oc_connect: "Wallet verbinden",
    oc_connecting: "Verbinde…",
    oc_connected: "Verbunden",
    oc_disconnect: "Trennen",
    oc_no_wallet: "Keine Wallet erkannt (MetaMask / Coinbase). Installiere eine Extension.",
    oc_wrong_chain: "Deine Wallet ist nicht auf Base L2.",
    oc_switch_chain: "Zu Base wechseln",
    oc_choose_wallet: "Wähle eine Wallet",
    tk_hero_eyebrow: "// BASE L2 · ERC-20 · LIVE ON-CHAIN",
    tk_hero_sub: "Der native Token von RE₿EL Academy und Shadow Network. Verdiene R₿L mit deiner Aktivität, tausche es gegen Belohnungen ein und transferiere es on-chain in deine Wallet auf Base L2.",
    tk_stat_price: "R₿L-Preis",
    tk_stat_supply: "Total Supply",
    tk_stat_fee: "Fee → Treasury",
    tk_stat_per_swap: "pro Swap",
    tk_stat_liq: "DEX-Liquidität",
    tk_swap_title: "Kaufe R₿L",
    tk_swap_sub: "Swap ETH → R₿L direkt aus deiner verbundenen Wallet auf Base L2. Liquidität 24/7.",
    tk_swap_chart: "Chart anzeigen",
    tk_balance_label: "Dein R₿L-Guthaben (RE₿EL Academy)",
    tk_balance_total: "Kumuliert gesamt:",
    tk_how_earn_title: "Wie R₿L verdienen",
    tk_login_sub: "Melde dich an, um dein R₿L-Guthaben zu sehen und Belohnungen einzulösen.",
    tk_redeem_title: "R₿L einlösen",
    tk_redeem_btn: "Einlösen",
    tk_redeem_ok: "Einlösung durchgeführt",
    tk_redeem_active: "Aktiv bis {when}",
    tk_history_title: "Verlauf",
    tk_history_empty: "Keine Aktivität. Veröffentliche eine Analyse, um deine ersten R₿L zu verdienen.",
    tk_def_coupon_name: "🛒 Shop-Rabatt",
    tk_def_coupon_desc: "Gutschein über -5€ einlösbar im RE₿EL Academy Shop.",
    tk_def_boost_name: "🚀 Feed-Boost 24h",
    tk_def_boost_desc: "Deine nächste Analyse wird 24 Stunden lang hervorgehoben im Shadow Network angezeigt.",
    tk_def_badge_name: "🎖️ Veteranen-Badge",
    tk_def_badge_desc: "Permanentes 'Veteranen'-Badge in deinem RE₿EL-Profil. Single-use.",
    tk_roadmap_title: "R₿L-Roadmap",
    tk_phase1_title: "Phase 1 — Abgeschlossen",
    tk_phase1_i1: "Deploy ERC-20 RE₿EL (R₿L) auf Base L2 via Thirdweb",
    tk_phase1_i2: "Bonding Curve aktiv — dynamischer Preis",
    tk_phase1_i3: "Treasury Wallet finanziert",
    tk_phase1_i4: "Off-chain-Ledger aktiv in RE₿EL Academy",
    tk_phase1_i5: "Earning Rates: Veröffentlichen +10 · Reaktion +1 · Richtig +50 · Referral +100",
    tk_phase2_title: "Phase 2 — Abgeschlossen",
    tk_phase2_i1: "R₿L-Zähler in Navbar · Einlösungen (Shop-Rabatt, Feed-Boost, Veteranen-Badge)",
    tk_phase2_i2: "Shadow Network: Analysen, Polls, Reposts, Mentions, USDC-Tips, Co-Firmen, kuratierte Listen",
    tk_phase2_i3: "KI-Mentor Claude (FREE 10 Nachr./Tag · PRO unbegrenzt) · Trading Journal PRO · Preis-Alerts",
    tk_phase2_i4: "Premium-Signale + Analisten-Abos via Stripe Connect (Split 80/20)",
    tk_phase2_i5: "Wöchentliche Challenges mit XP + Level-System (Rookie · Trader · Shadow · Legend)",
    tk_phase3_title: "Phase 3 — Abgeschlossen (on-chain + Web3)",
    tk_phase3_i1: "Konvertierung virtuell → on-chain 1:1 mit Treasury-Verifizierung (Base L2)",
    tk_phase3_i2: "Dual Ledger: off-chain + on-chain parallel laufend",
    tk_phase3_i3: "Wallet Connect EIP-1193 (MetaMask + Coinbase) mit Auto-Switch zu Base",
    tk_phase3_i4: "Co-Analyst Split (F5.5): Automatischer Stripe Transfer an Co-Unterzeichner nach Zahlung",
    tk_phase3_i5: "KI-Mentor mit Historie, Live-Candle-Chart (DexScreener · TradingView)",
    tk_phase4_title: "Phase 4 — Abgeschlossen (Liquidität & Listings)",
    tk_phase4_i1: "Uniswap (Base) — gelistet und operativ",
    tk_phase4_i2: "Liquiditätspool ETH/R₿L auf Uniswap — aktiv",
    tk_phase4_i3: "Aerodrome Finance (nativer DEX Base) — gelistet",
    tk_phase4_i4: "PancakeSwap (Base) — gelistet",
    tk_phase4_i5: "CoinGecko + CoinMarketCap — Listing aktiv",
    tk_phase4_i6: "Market Maker aktiv + Snapshot/Claim für frühe Holder",
    tk_phase5_title: "Phase 5 — Abgeschlossen (komplettes RE₿EL-Ökosystem)",
    tk_phase5_i1: "Governance: Community-Abstimmung RE₿EL mit R₿L",
    tk_phase5_i2: "Airdrop an RE₿EL Proof™-Diplom-Holder",
    tk_phase5_i3: "R₿L als Zugang zu Kursen und PRO-Mitgliedschaften in RE₿EL Academy",
    tk_phase5_i4: "Copy Simulator mit R₿L",
    tk_phase5_i5: "TrendIA-Integration — Analysen mit R₿L",
    tk_phase6_title: "Phase 6 — Fortgeschrittene Token Economy",
    tk_phase6_i1: "R₿L Vault — Yield Sharing mit Akademie-Einnahmen · 20% jeder PRO-Zahlung geht in Vault · monatliche Ausschüttung",
    tk_phase6_i2: "Mechanisches R₿L-Burning — 5% jeder PRO-Zahlung permanent verbrannt · deflationäres Supply",
    tk_phase6_i3: "Natives Swap-Widget auf rebelbtc.com — kaufe R₿L direkt auf der Plattform · Uniswap V3 Base",
    tk_phase6_i4: "Echtzeit-Tokenomics-Dashboard — Preis · Market Cap · Holders · 24h-Volumen · LP gesperrt",
    tk_phase6_i5: "Promo-Banner 50% Rabatt PRO mit R₿L — sichtbar auf der gesamten Plattform für User ohne PRO",
    tk_phase6_i6: "Listing auf CoinGecko — Antrag gesendet · Review in 10-20 Werktagen",
    tk_phase6_i7: "Listing auf CoinMarketCap — Antrag gesendet · Ticket #1372525",
    tk_phase7_title: "Phase 7 — Ökosystem-Expansion",
    tk_phase7_i1: "RE₿EL Wallet — Mobile App mit eigener Marke (iOS + Android)",
    tk_phase7_i2: "Trading-Turniere mit R₿L als Preis",
    tk_phase7_i3: "RE₿EL Mentors — Analysten kassieren in R₿L",
    tk_phase7_i4: "Live-Klassen tokenisiert mit R₿L als Eintritt",
    tk_phase7_i5: "NFT Achievement Badges für Meilensteine",
    tk_phase7_i6: "RE₿EL DAO — vollständige On-chain-Governance",
    tk_phase7_i7: "Listing auf CEX (MEXC, Gate.io, BitMart)",
    tk_phase7_i8: "Vollständige TrendIA-Integration in der Plattform",
    common_back: "// SHADOW NETWORK",
    common_login: "Anmelden",
    common_loading: "Lade…",
    common_save: "Speichern",
    common_cancel: "Abbrechen",
  },
};

// Replace {placeholders} with values from a params object.
const _fmt = (str, params) => {
  if (!params) return str;
  return Object.keys(params).reduce(
    (acc, k) => acc.replace(new RegExp(`\\{${k}\\}`, "g"), params[k]),
    str
  );
};

// Get a translation by key. Falls back to EN → ES if missing in target lang.
export const tFases = (lang, key, params) => {
  const dict = SHADOW_FASES_I18N[lang] || SHADOW_FASES_I18N.en || SHADOW_FASES_I18N.es;
  const str = dict[key] || SHADOW_FASES_I18N.en?.[key] || SHADOW_FASES_I18N.es[key] || key;
  return _fmt(str, params);
};

export default SHADOW_FASES_I18N;
